
import { Options } from "vue-class-component";

import { List, Skeleton } from "vant";
import BasePage from "@/common/BasePage"; // @ is an alias to /src
import StaffItem from "@/components/item/StaffItem.vue";
import AppUtil from "@/util/AppUtil";

@Options({
  components: {
    [Skeleton.name]: Skeleton,
    [List.name]: List,
    StaffItem,
  },
})
/**员工列表页 */
export default class StaffList extends BasePage {
  loading = false;
  finished = false;
  error = false;
  list: number[] = [];

  private reqData = { page: 0, limit: 10 };
  // mounted(): void {

  // }
  /**页面标题*/
  _title = "员工";
  backcolor = "#ffffff";
  private onLoad() {
    // this.list=[1,2,3];
    // this.finished=true;
    this.reqData.page++;
    AppUtil.request(
      {
        url: "/zhTenant/tenant/getStaffList",
        method: "post",
        data: this.reqData,
      },
      this.req_items
    );
  }
  get firstLoad(){
      return this.loading&&this.reqData.page==1;
  }
  private req_items(res: any) {
    console.log("req_items", res);
    this.finished = true; //当res.data为空时，结束请求，兼容请求过程中后台新增情况
    this.loading = false;
    if (res.data && res.data.length) {
      res.data.map((val: any) => {
        val.thumb = this.get_thumb(val.photoWall, 200, 220);
        val.serviceNum = val.serviceNum || 0; //如果后台没有返回服务数量，就默认零
      });
      this.reqData.page > 1
        ? (this.list = this.list.concat(res.data))
        : (this.list = res.data);
      this.finished = this.list.length >= res.count; //通过数量判断是否已经结束
    }
  }
}
